/** TODO */
export const environment = {
  production: false,
  environment: 'tst',
  defaultLanguage: 'en',
  wwwBaseUrl: 'https://sapupload.d931fea5.pincubator.tech',
  apiBaseUrl: 'https://api.d931fea5.pincubator.tech',
  okta: {
    authBaseUrl: 'https://sso.claas.com',
    clientId: '0oauecig8u5nzk1Pw417',
    redirectUri: 'https://rdv.0abddbc0.pincubator.tech/security/okta/login',
    issuer: 'https://sso.claas.com/oauth2/sso',
  },
};
